import * as React from 'react';
const InsonniaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}`}</style>
    </defs>
    <path
      d="M84.54 103.01c-4.86-14.91.25-30.66 11.63-40.1-4.55-.29-9.23.23-13.84 1.73-19.52 6.35-30.19 27.33-23.83 46.85 6.35 19.52 27.33 30.19 46.85 23.83 4.6-1.5 8.69-3.83 12.2-6.75-14.76-.93-28.15-10.65-33.01-25.57Z"
      style={{
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '3.89px',
        stroke: primaryColor || '#282828',
      }}
    />
    <path
      d="m106.17 80.15 3.26 6.52 6.52 3.26-6.52 3.26-3.26 6.52-3.27-6.52-6.52-3.26 6.52-3.26zM131.59 66.45l3.92 7.83 7.82 3.91-7.82 3.91-3.92 7.83-3.91-7.83-7.82-3.91 7.82-3.91zM125.73 99.71v11.73M131.59 105.57h-11.73"
      className="prefix__cls-1"
    />
  </svg>
);
export default InsonniaIcon;
